import { BaseProgressBar } from 'app/components/BaseProgressBar';
import React, { useMemo } from 'react';
import './InitialPlanEndsOn.less';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

interface Props {
  endsOn: string;
  formattedEndsOn: string;
}

export default function InitialPlanEndsOn({ endsOn, formattedEndsOn }: Props) {
  const { t } = useTranslation();

  const progress = useMemo(() => {
    const endDate = moment(endsOn).startOf('day');
    const today = moment().startOf('day');

    const daysLeft = Math.max(0, endDate.diff(today, 'days'));
    const daysPassed = 1095 - daysLeft;

    const progress = (daysPassed / 1095) * 100;

    return Math.min(100, Math.max(0, progress));
  }, [endsOn]);

  return (
    <div className="initial-plan-ends-on">
      <div className="initial-plan-ends-on__info">
        <span className="initial-plan-ends-on__title">
          {t(
            'subscriptions.manage_your_plan.initial_premium_telematics_plan.expires_on',
          )}{' '}
          <span className="initial-plan-ends-on__due-to">
            {formattedEndsOn}
          </span>
        </span>

        <BaseProgressBar value={progress} />

        <p className="initial-plan-ends-on__description">
          {t(
            'subscriptions.manage_your_plan.initial_premium_telematics_plan.expires_on_subtitle',
          )}
        </p>
      </div>
    </div>
  );
}
